import { memo } from "react";

import { Text } from "@react/components/Text";
import { tw } from "classnames";

const styles = tw(
  "w-full",
  "text-center",
  "bg-blue-500",
  "text-char-50",
  "py-1.5",
  "md:py-2",
  "px-6"
);

const CartBannerBase = ({ content }: { content: string }) => {
  return (
    <div className={styles}>
      <Text leading="tight">
        <span
          dangerouslySetInnerHTML={{
            __html: content,
          }}
        ></span>
      </Text>
    </div>
  );
};

export const CartBanner = memo(CartBannerBase);
